import { CEFR_LEVELS, LISTENING_DIFFICULTY_THRESHOLDS } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { listeningUserStateSchema } from '../schemas';

const listeningReductionNoteSchema = z.object({
  label: z.string(),
  note: z.string(),
  matchedText: z.string(),
});

const listeningSessionClipSchema = z.object({
  id: z.number().int().positive(),
  challengeId: z.number().int().positive(),
  collectionId: z.number().int().positive().nullable(),
  durationMs: z.number().int().nonnegative(),
  transcript: z.string(),
  startMs: z.number().int().nonnegative(),
  endMs: z.number().int().positive(),
  basePath: z.string().nullable(),
  verticalPath: z.string().nullable(),
});

const listeningSessionPhraseSchema = z.object({
  id: z.number().int().positive(),
  title: z.string(),
  definition: z.string(),
  cefrLevel: z.enum(CEFR_LEVELS),
});

const listeningSessionItemSchema = z.object({
  clip: listeningSessionClipSchema,
  phrase: listeningSessionPhraseSchema,
  words: z.array(z.string()),
  wordsPerSecond: z.number().nonnegative(),
  difficulty: z
    .number()
    .int()
    .min(1)
    .max(LISTENING_DIFFICULTY_THRESHOLDS.length + 1),
  reductionNotes: z.array(listeningReductionNoteSchema),
  reviewed: z.boolean(),
  state: listeningUserStateSchema.nullable(),
});

const getListeningSessionV1DataSchemaDefinition = z.object({
  items: z.array(listeningSessionItemSchema),
});

export const getListeningSessionV1DataSchema: typeof getListeningSessionV1DataSchemaDefinition =
  getListeningSessionV1DataSchemaDefinition;

export type IGetListeningSessionV1Data = z.infer<typeof getListeningSessionV1DataSchema>;

export const getListeningSessionV1ResponseSchema: z.ZodSchema<IAPI<IGetListeningSessionV1Data>> =
  createApiResponseSchema(getListeningSessionV1DataSchema) as z.ZodSchema<
    IAPI<IGetListeningSessionV1Data>
  >;

export type IGetListeningSessionV1Response = IAPI<IGetListeningSessionV1Data>;
